import { Component, OnInit, Input } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-ag-overview',
  templateUrl: './ag-overview.component.html',
  styleUrls: ['./ag-overview.component.css', '../../../quote.component.css']
})
export class AgOverviewComponent implements OnInit {
  quote;
  quoteData;
  CoverTo;
  @Input() set quoteDetails(value: any) {
    if (value) {
      this.quote = value;
      this.quoteData = value.application || value;
      const inceptionDate = this.quoteData.inception_date;
      if (inceptionDate) {
        let maxDate = new Date(inceptionDate).setFullYear(new Date(inceptionDate).getFullYear() + 1);
        this.CoverTo = new Date(new Date(maxDate).getTime() - (24 * 60 * 60 * 1000));
      }
    }
  }

  constructor(private sessionSt: LocalStorageService) { }
  isAdmin = false;
  ngOnInit(): void {
    if (this.sessionSt.retrieve('is_admin')) { this.isAdmin = true; }
  }
}
